
const ShopifySettings = Shopify.settings;

(function($) {
  $.fn.inputFilter = function(inputFilter) {
    return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function() {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  };
 }(jQuery));
 
 
 function format_to_Money(n, c, d, t) {
   var c = isNaN(c = Math.abs(c)) ? 2 : c,
       d = d == undefined ? "." : d,
       t = t == undefined ? "," : t,
       s = n < 0 ? "-" : "",
       i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
       j = (j = i.length) > 3 ? j % 3 : 0;
   return '$ ' + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
   
 };
 
 
 $(function() {
   
   if( $('body').attr('template') == 'cart' ){
     
     
     $( "#input-date-pick-up" ).keypress(function(e) {
       e.preventDefault();
       return;
     });
     
     
     function check_zipcode(zipcode){
       
       $('div[loading_date_picker]').css('display','');
       $('div[zip_question]').css('display','');
       
       $.post('https://doosestudio.app/apps/zana-alquimia-ws/check-zipcode.php',{zipcode:zipcode},function(data){
         
         var obj = JSON.parse(data);
         
         if (obj.with_deliver == true) {
           var h3 = ShopifySettings.shipping_hack_zone_date_message+' <span>'+obj.day+'</span>';
           var p = ShopifySettings.shipping_hack_select_date_message;
         }else{
           var h3 = ShopifySettings.shipping_hack_no_delivery_message;
           var p = ShopifySettings.shipping_hack_select_date_message_pickup;
         }
         
         if( obj.hour_message == true ){           
           $('#extra_hour_message').css('display','inline-block');           
         }         
         
         $('div[zip_anwser] h6').html(h3);
         $('div[zip_anwser] p').html(p);
         $('div[zip_anwser]').css('display','inline-block');
         
         $('div[loading_date_picker]').css('display','none');
         
         var today_date = new Date();
         
         today_date.setDate(today_date.getDate() + 1);
         
         if( today_date.getHours() >= Number(ShopifySettings.shipping_hack_closed_hour) ){
           
           today_date.setDate(today_date.getDate() + 1);
           $('#extra_hour_message').css('display','inline-block');
           
         }
         
         today_date.setHours(0,0,0,0);
         
         let disabledDates = [];
         
         let block_dates = $('#to_checkout').attr('block_dates');
         
         if ( block_dates.length > 0 ){ disabledDates = block_dates.split(','); }         
         
         $('#datetimepicker1').datetimepicker({
           format: "YYYY-MM-DD",
           useCurrent: false,
           debug : true,
           minDate: today_date,
           disabledDates: disabledDates,
           daysOfWeekDisabled: obj.block_days,
           locale: 'es-es'
         });
         
         
       });
       
     }
     
     
     $.get('/cart.json',function(cart){
       
       $.each(cart.items,function(i,item){
         if (item.variant_id == '37760780239006') {
           
           var item_id = item.id;
           
           $.ajax({
             url:'/cart/change.js',
             data:{id:item_id,'quantity':0},
             type: 'POST',
             dataType: "javascript",
             success: function( response ){},
             error: function( error ){},
             complete: function( complete ){}
           });
           
         }
       })
       
     });
     
     
     $("#zipcode-input").inputFilter(function(value) { return /^\d*$/.test(value); });
     
     $(document).on('click','[pick-up-in-store]',function(){
       
       $('div[loading_date_picker]').css('display','');
       $('div[shpping_method]').css('display','');
       $('#date_picker_back').attr('back','shpping_method');
       
       
       $.ajax({
         url:'/cart/update.js',
         data:"attributes[shipping-method]=pickup-in-store",
         type: 'POST',
         dataType: "javascript",
         success: function( response ){},
         error: function( error ){},
         complete: function( complete ){}
       });
       
       
       setTimeout(function(){
         
         var h3 = ShopifySettings.shipping_hack_local_pickup_message;
         var p = ShopifySettings.shipping_hack_select_date_message_pickup;
         
         $('div[zip_anwser] h6').html(h3);
         $('div[zip_anwser] p').html(p);
         $('div[zip_anwser]').css('display','inline-block');
         
         $('div[loading_date_picker]').css('display','none');
         
         var today_date = new Date();
         
         today_date.setDate(today_date.getDate() + 1);
         
         if( today_date.getHours() >= Number(ShopifySettings.shipping_hack_closed_hour) ){
           
           today_date.setDate(today_date.getDate() + 1);
           $('#extra_hour_message').css('display','inline-block');
           
         }
         
         today_date.setHours(0,0,0,0);
         
         let disabledDates = [];
         
         let block_dates = $('#to_checkout').attr('block_dates');
         
         if ( block_dates.length > 0 ){ disabledDates = block_dates.split(','); }
         
         $('#datetimepicker1').datetimepicker({
           format: "YYYY-MM-DD",
           useCurrent: false,
           debug : true,
           minDate: today_date,
           disabledDates: disabledDates,
           daysOfWeekDisabled: [0,6],
           locale: 'es-es'
         });
         
       },1000);
       
     });
     
     
     $(document).on('click','#ship-to-client',function(){
       
       $.post('/cart/update.js', "attributes[shipping-method]=ship-to-client");
       
       $('div[loading_date_picker]').css('display','');
       $('div[shpping_method]').css('display','');
       $('#date_picker_back').attr('back','zip_question');
       
       setTimeout(function(){
         $('div[zip_question]').css('display','inline-block');
         $('div[loading_date_picker]').css('display','none');
       },1000);
     });
     
     
     $(document).on('click','#zipcode-btn',function(){
       check_zipcode($('#zipcode-input').val());
     });
     
     $(document).on('keypress','#zipcode-input',function(e) {
       if(e.which == 13) {
         check_zipcode($('#zipcode-input').val());
       }
     });
     
     
     $("#datetimepicker1").on("dp.change", function (evt) {
       
       $('#select_date_btn').addClass('actived');
       $('#date_picker_back').attr('back','zip_question');
       
     });
     
     
     $(document).on('click','#select_date_btn.actived',function(){
       
       $('div[loading_date_picker]').css('display','');
       $('.date-picker-section').css('display','');
       
       var datepickup = $('[name="attributes[date-pick-up]"]').val()
       
       $.ajax({
         url:'/cart/update.js',
         data:"attributes[date-order]="+datepickup,
         type: 'POST',
         dataType: "javascript",
         success: function( response ){},
         error: function( error ){},
         complete: function(){
           
           setTimeout(function(){
             
             // ADDING GUIDE PRODUCT
             
             var product_personalize = 37760780239006;
             
             $.ajax({
               url:'/cart/add.js',
               data:{quantity: 1,id: product_personalize,properties:{datepickup:datepickup}},
               type: 'POST',
               dataType: "text",
               success: function( response ){
                 //alert( 'response: '+response );
               },
               error: function( error ){
                 //alert( "ERROR:", error );
               },
               complete: function(){
                 
                 window.location.href = "/checkout";
                 
               }
             });
             
           },1000);
           
           
         }
       });
       
       
     });
     
     
     $(document).on('click','.regresar-date-picker',function(e){
       
       e.preventDefault();
       
       var back = $(this).attr('back');
       $('div[loading_date_picker]').css('display','');
       $('.date-picker-section').css('display','');
       
       if( back == 'shpping_method' || back == 'zip_question' ){ $("#datetimepicker1").data('DateTimePicker').destroy(); }
       
       if ( back == 'shpping_method_o' ) { back = 'shpping_method' }
       
       setTimeout(function(){
         $('div['+back+']').css('display','inline-block');
         $('div[loading_date_picker]').css('display','none');
       },1000);
       
     });
     
     $(document).on('click','#close_popup',function(){
       
       $('div[loading_date_picker]').css('display','');
       $('.date-picker-section').css('display','');
       $('div[shpping_method]').html('').css('display','');
       
       setTimeout(function(){
         $('#date_picker_out').css('display','none');
       },500);
       
     });
     
     
     $(document).on('click','#to_checkout',function(e){
       
       $('#date_picker_out').css('display','');
       
       var minimun_shipping = Number($(this).attr('minimun_shipping'));
       
       
       setTimeout(function(){
         
         $.get('/cart.json',function(cart){
           
           var total_price = (cart.total_price/100);
           
           var html = '';
           
           html += '<p class="date-picker-title">¿Prefieres recoger tu pedido (en Montes Urales 425, Lomas de Chapultepec) o que lo enviemos<br>a tu domicilio?</p><div style="text-align:center;" class="col-lg-12 col-md-12"><span class="btn btn--primary uppercase bt btn_select_shpping_method" pick-up-in-store >';
           html += '<p>Recoger pedido</p></span><span class="btn btn--primary uppercase bt btn_select_shpping_method" ';
           
           if ( minimun_shipping > total_price ) { html += ' disabled '; }else{ html += ' id="ship-to-client" '; }
           
           html += ' >';
           
           html += '<p>Envío a Domicilio</p></span>';
           
           if ( minimun_shipping > total_price ) {
             
             var diff_money = (minimun_shipping - total_price);
             
             html += '<p>Para recibir en tu domicilio debes agregar '+format_to_Money(diff_money)+'<br> al carrito.</p><a href="/collections/lechitas" class="">Seguir comprando</a>';
             
           }
           
           html += '</div>';
           
           $('div[shpping_method]').html(html).css('display','inline-block');
           $('div[loading_date_picker]').css('display','none');
           
         });
         
       },1500);
       
     });
     
     
   }
   
 });